module.exports = __webpack_public_path__ + "img/NOVA.14732fe4.png";